import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'terms-of-service';
export const GREEK_ASSET_NAME = 'terms-of-service-greek';
export const SPANISH_ASSET_NAME = 'terms-of-service-spanish';
import { languageType } from '../../util/languageType';

const languageAssetName = () => {
  const language = languageType();
  if (language === 'el') return GREEK_ASSET_NAME;
  if (language === 'es') return SPANISH_ASSET_NAME;
  return ASSET_NAME;
};

export const loadData = (params, search) => dispatch => {
  const assetName = languageAssetName();
  const pageAsset = { termsOfService: `content/pages/${assetName}.json` };
  return dispatch(fetchPageAssets(pageAsset, true)).then(res => {
    // Fall back to the English asset until the Spanish translation exists in the console.
    if (!res && assetName !== ASSET_NAME) {
      return dispatch(
        fetchPageAssets({ termsOfService: `content/pages/${ASSET_NAME}.json` }, true)
      );
    }
    return res;
  });
};
